export default __webpack_public_path__ + "static/media/exclude.3b7ddb48.png";